import React from 'react';
import { Check } from 'lucide-react';
export const ParaQuienEs: React.FC = () => {
  const items = ['Tu hijo ama Disney', 'Le encanta colorear', 'Querés menos tiempo frente a pantallas', 'Buscás entretenimiento saludable', 'Querés imprimir cuando quieras', 'Querés estimular creatividad e imaginación', 'Buscás una actividad económica y duradera'];
  return <section className="py-7 px-4 bg-cream" data-id="element-161">
      <div className="max-w-2xl mx-auto" data-id="element-162">
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet text-center leading-tight mb-2" data-id="element-163">
          Una actividad mágica, creativa y{' '}
          <span className="text-gold-dark" data-id="element-164">sin pantallas</span>
        </h2>
        <p className="text-center text-textsoft mb-6 text-base font-semibold" data-id="element-165">
          Perfecta para entretener, compartir en familia y crear momentos
          inolvidables.
        </p>

        <div className="bg-white rounded-3xl border-t-[6px] border-gold p-5 sm:p-7 shadow-card" data-id="element-166">
          <p className="text-center font-rounded font-bold text-textsoft uppercase text-xs tracking-widest mb-4" data-id="element-167">
            Esta biblioteca es para vos si...
          </p>
          <ul className="space-y-3" data-id="element-168">
            {items.map((item, idx) => <li key={idx} className="flex items-start gap-3 pb-3 border-b-2 border-dashed border-cream-dark last:border-b-0 last:pb-0" data-id="element-169">
                <div className="flex-shrink-0 mt-1 w-5 h-5 rounded-full bg-brandgreen flex items-center justify-center" data-id="element-170">
                  <Check className="text-white w-3 h-3" strokeWidth={4} data-id="element-171" />
                </div>
                <span className="text-violet font-bold text-base sm:text-lg leading-snug" data-id="element-172">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
};